// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__20jzJ","addWidgetButton":"Header_addWidgetButton__1NhWJ","dashboardTabs":"Header_dashboardTabs__wVswS","active":"Header_active__18x6m"};